import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
import * as MimeTypes from './MimeTypes';
const compareObjects = require('fast-deep-equal');
const saveAs = require('file-saver');

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { store as RMStore, dispatcher as RMDisp, actions as RMActions } from '../flux/glob';
import * as Config from '../config';
import * as Globalization from '../../../../_common/platform/ts/Globalization';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import ImageResourceDialog, { IImageResourceDialogResourceValue } from './ImageResourceDialog';
import ResourceList from './ResourceList';
import DirResourceTree from './DirResourceTree';
import { DirsTree, IExpandedItems } from '../../../../pdc-platform/src/tsx/DirsTree';
import { IResourceManagerStoreState, WidgetStore } from '../stores/WidgetStore';
import * as permissions from '../../../../_common/platform/ts/permissions';
import { IMarkedItems } from '../../../../pdc-platform/src/ts/Interfaces';

require('../../sass-main/pdc-widget-resource-manager.sass');

function getStoredViewNumber(glob: IGlob) {
    const result = parseInt(glob.AppStore.getFromLocalStorage('view'));

    return Number.isNaN(result) ? 0 : result;
}

function getBaseName(fullPath: string) {
    return fullPath.replace(/^.*[\\\/]/, '').replace(/\.[^.$]+$/, '');
}

export function createResourceBrowserDialog(glob: IGlob, instanceId, successCallback, zIndex?) {
    let config: any = {
        deny: false,
        confirmTitle: 'Insert',
        fullHeight: true,
        componentProps: {
            glob,
            instanceId
        },
        Component: ResourceBrowser
    };

    if (zIndex != null) {
        config.zIndex = zIndex;
    }

    glob.DialogActions.createDialog(
        'Browse Resources',
        null,
        () => {
            successCallback();
        },
        () => {},
        () => {},
        'custom',
        //{
        //    deny: false,
        //    confirmTitle: 'Insert',
        //    Component: ResourceBrowser,
        //    fullHeight: true,
        //    componentProps: {
        //        glob,
        //        instanceId
        //    }
        //}
        config
    );
}

export interface IResourceBrowserProperties {
    name: string;
    instanceId;
    store: WidgetStore;
    asCKEditExternalBrowser: boolean;
    glob: IGlob;
}

interface IResourceBrowserState {
    storeState: IResourceManagerStoreState;
    selectedDirId: number;
    selectedResources: IMarkedItems;
    dirTreeInstanceId: string;
    data;
    name: string;
    downloading: boolean;
    refreshCount: number;
    showViewMenu: boolean;
    RMState;
    //instanceId;
    expandedItems: IExpandedItems;
}

export class ResourceBrowser extends React.Component<IResourceBrowserProperties, IResourceBrowserState> {
    //dragScope: string = 'resource-drag-scope';

    private references: {
        btnView?: HTMLElement;
        menuView?: HTMLElement;
        fileUpload?: HTMLInputElement;
    } = {};

    constructor(props) {
        super(props);

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            ...this.getState(),
            selectedDirId: -1,
            selectedResources: {},
            dirTreeInstanceId: '',
            data: null,
            name: this.props.name,
            downloading: false,
            refreshCount: 0,
            showViewMenu: false,
            expandedItems: {}
        };
    }

    private getState() {
        // The WidgetStore is undefined when the ResourceBrowser is used as
        // Component, but not as a widget
        const storeState: IResourceManagerStoreState = this.props.store == null ? {} : this.props.store.getState();
        const rmState = RMStore.getInstanceState(this.props.instanceId);

        return {
            storeState,
            RMState: rmState
        };
    }

    getWidgetParameters = () => {
        if (
            this.state.storeState != null &&
            !_.isEmpty(this.state.storeState) &&
            this.state.storeState.data != null &&
            this.state.storeState.data.values != null
        ) {
            return this.state.storeState.data.values[Config.moduleName];
        } else {
            return null;
        }
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.store != null) {
            this.props.store.addChangeListener(this.handleOnStoreChange);
        }

        if (_.isEmpty(RMStore.glob)) {
            RMStore.glob = window['pdc'].platform.glob;
        }

        let thisParams = this.getWidgetParameters();
        if (thisParams != null) {
            this.setCulture(thisParams);
        }

        RMStore.addChangeListener(this.handleOnStoreChange);
        this.props.glob.DirsStore.addChangeListener(this.handleOnDirChange);
        RMActions.getResourceTreeRoot(this.props.instanceId);
    }

    // private applyCultureCallback = () => {
    //     let thisParams = this.getWidgetParameters();
    // }

    private setCulture = (prevParams) => {
        let self = this;
        let theme = _.extend({}, this.state.storeState.options.theme);

        let myTheme = appTheme.getThemeObj(theme);
        const widgetCulture = Globalization.getWidgetCulture(myTheme);

        Globalization.applyCulture(widgetCulture, function () {
            let thisParams = self.getWidgetParameters();

            if (!compareObjects(prevParams, thisParams)) {
                this.setState(self.getState.call(self));

                let config: any = self.state.storeState.data.values[Config.moduleName];

                config.currencyFromTheme = Globalization.getWidgetCulture(myTheme);
            }
        });
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);

        if (this.props.store != null) {
            this.props.store.removeChangeListener(this.handleOnStoreChange);
        }

        RMStore.removeChangeListener(this.handleOnStoreChange);
        this.props.glob.DirsStore.removeChangeListener(this.handleOnDirChange);
    }

    handleClickOutside(event) {
        if (
            event.target.innerText != 'View' &&
            event.target.innerText != 'List' &&
            event.target.innerText != 'Large Icons' &&
            event.target.innerText != 'Small Icons'
        ) {
            this.setState(
                _.extend(this.getState.call(this), {
                    showViewMenu: false
                })
            );
        }
    }

    componentDidUpdate(prevProps: IResourceBrowserProperties, prevState: IResourceBrowserState) {
        const widgetParameters = this.getWidgetParameters();

        // no theme, no culture in component mode
        if (widgetParameters != null) {
            const theme = this.state.storeState.options.theme;
            const prevParams = prevState.storeState.data.values[Config.moduleName];
            const prevTheme = prevState.storeState.options.theme;

            this.setCulture(prevParams);

            if (!compareObjects(theme, prevTheme)) {
                if (!compareObjects(theme, widgetParameters.theme._custom)) {
                    this.setState(this.getState.call(this));
                }
            } else if (!compareObjects(prevParams, widgetParameters)) {
                this.setState(this.getState.call(this));
            } else if (!compareObjects(theme, prevTheme)) {
                this.setState(this.getState.call(this));
            } else if (this.state.RMState.globalStateChanged != prevState.RMState.globalStateChanged) {
                this.setState(this.getState.call(this));
            }
        }

        if (
            this.state.storeState.refreshChanged != null &&
            this.state.storeState.refreshChanged != prevState.refreshCount &&
            this.state.selectedDirId > 0
        ) {
            this.setState(
                _.extend(this.getState.call(this), {
                    refreshCount: this.state.storeState.refreshChanged
                })
            );
            RMActions.getDirContent(this.props.instanceId, this.state.selectedDirId);
        }

        let btnViewEl = this.references.btnView;
        let menuViewEl = this.references.menuView;

        if ($(btnViewEl) && $(btnViewEl).offset() && $(menuViewEl)) {
            let left = $(btnViewEl).offset().left;
            let top = $(btnViewEl).offset().top + $(btnViewEl).height() + 3;

            $(menuViewEl).offset({ left, top });
        }
    }

    public static getFirstSelectedResource(instanceId: string) {
        return RMStore.getFirstSelectedResource(instanceId);
    }

    handleOnStoreChange = () => {
        if (this.state.RMState.resourceTreeRootDirId !== -1 && this.state.selectedDirId === -1) {
            this.setState(
                _.extend(this.getState.call(this), {
                    selectedDirId: this.state.RMState.resourceTreeRootDirId,
                    dirTreeInstanceId: 'resource-tree-' + this.state.RMState.resourceTreeRootDirId
                })
            );
        } else {
            this.setState(this.getState.call(this));
        }
    };

    handleOnDirChange = () => {
        const data = this.props.glob.DirsStore.getInstanceData(this.state.dirTreeInstanceId);

        if (data == null) {
            this.props.glob.AppActions.dirsContentLoad(
                this.state.dirTreeInstanceId,
                this.state.RMState.resourceTreeRootDirId
            );
        } else {
            this.setState(this.getState.call(this));
        }
    };

    checkDirectorySelected = (allowAtRoot: boolean) => {
        if (!allowAtRoot && this.state.selectedDirId === this.state.RMState.resourceTreeRootDirId) {
            this.props.glob.AppActions.showNotification_Fail('Any operations with Resource Root are prohibited');
            return false;
        }

        if (this.state.selectedDirId < 0 || this.state.dirTreeInstanceId === '') {
            this.props.glob.AppActions.showNotification_Success('Select a folder for the operation, please');
            return false;
        }

        return true;
    };

    private checkResourceSelected = () => {
        if (_.isEmpty(this.state.selectedResources)) {
            this.props.glob.AppActions.showNotification_Success('Select the Resource for operation, please');
            return false;
        }

        return true;
    };

    private handleOnAddNewDir = () => {
        if (this.checkDirectorySelected(true)) {
            let expandedItems = [];

            expandedItems[this.state.selectedDirId] = true;
            this.setState(
                _.extend(this.getState.call(this), {
                    expandedItems: expandedItems
                })
            );
            this.props.glob.AppActions.dirsCreateStart(this.state.selectedDirId, this.state.dirTreeInstanceId);
        }
    };

    private handleOnDeleteDir = (e) => {
        if (this.checkDirectorySelected(false)) {
            let dir_obj = RMStore.getSelectedDir(this.props.instanceId);
            let dirContent = RMStore.getInstanceState(this.props.instanceId).dirContent;
            let deleteSubItemsToo = true;
            let params = {};
            let prompt;

            if (dirContent.length > 0 || dir_obj.subdirlist.length > 0) {
                deleteSubItemsToo = false;

                params = {
                    cancelTitle: 'Delete',
                    deny: true,
                    confirmTitle: '',
                    confirm: false,
                    draggable: true,
                    resizable: false,
                    Component: BooleanField,
                    componentOptions: {
                        onChange: (val) => (deleteSubItemsToo = val),
                        title: 'Delete including sub-folders and sub-items'
                    }
                };

                prompt = `Folder '${dir_obj.name}' has sub-items. Please, confirm the action.`;
            } else {
                params = {
                    cancelTitle: 'Delete',
                    deny: true,
                    confirmTitle: '',
                    confirm: false,
                    draggable: true,
                    resizable: false
                };

                prompt = `Folder '${dir_obj.name}' is empty and can be deleted safely. Please, confirm the action.`;
            }

            this.props.glob.DialogActions.createDialog(
                `Delete the folder '${dir_obj.name}'`,
                prompt,
                () => {},
                () => {
                    this.props.glob.AppActions.dirsDelete(
                        this.state.selectedDirId,
                        this.state.dirTreeInstanceId,
                        dir_obj.name,
                        deleteSubItemsToo
                    );
                    this.handleDirSelect(this.props.instanceId, this.state.RMState.resourceTreeRootDirId);
                },
                () => {},
                'custom',
                params
            );

            e.stopPropagation();
            e.preventDefault();
        }
    };

    private renameDir = (e) => {
        if (this.checkDirectorySelected(false)) {
            this.props.glob.AppActions.dirsRenameStart(this.state.selectedDirId, this.state.dirTreeInstanceId);
        }
    };

    private editPermissions = () => {
        if (this.checkDirectorySelected(true)) {
            let obj = RMStore.getSelectedDir(this.props.instanceId);
            this.props.glob.AppActions.permissionsDirShow(this.state.selectedDirId, obj.name);
        }
    };

    private handleOnDeleteResourceButtonClick = () => {
        if (this.checkResourceSelected()) {
            this.props.glob.DialogActions.createDialog(
                'Delete resource',
                'Selected resource will be deleted' + '. Please, confirm this action.',
                () => {},
                () => {
                    RMActions.delete(
                        this.props.instanceId,
                        this.state.selectedDirId,
                        _.keys(this.state.selectedResources)
                    );
                },
                () => {},
                'confirm',
                {
                    confirmTitle: null,
                    cancelTitle: 'Delete'
                }
            );
        }
    };

    private handleOnRenameResourceButtonClick = () => {
        if (this.checkResourceSelected()) {
            const resourceIDs = _.keys(this.state.selectedResources);

            if (resourceIDs.length > 0) {
                RMActions.resourceRenameStart(this.props.instanceId, resourceIDs[0]);
            }
        }
    };

    private handleDirSelect = (instanceId, id) => {
        RMActions.getDirContent(this.props.instanceId, id);

        this.setState({
            //instanceId: instanceId,
            selectedDirId: id,
            selectedResources: {}
        });

        RMActions.setResourceSelected(this.props.instanceId, {});
    };

    private handleOnResourceSelected = (selectedResources: IMarkedItems) => {
        RMActions.setResourceSelected(this.props.instanceId, selectedResources);
        this.setState({
            selectedResources: selectedResources
        });
    };

    private upload = (e) => {
        // update State with this new Entity:
        let resourceValue = {
            resId: 0,
            name: ''
        };

        this.props.glob.DialogActions.createDialog(
            'Upload',
            null,
            () => {},
            () => {},
            () => {},
            'custom',
            {
                deny: false,
                confirm: false,
                FooterComponent: PopupFooterComp,
                footerComponentProps: {
                    resourceValue: resourceValue,
                    text: 'Upload',
                    component: ImageResourceDialog
                },
                Component: ImageResourceDialog,
                componentOptions: {
                    resourceValue: resourceValue,
                    selectedDirId: this.state.selectedDirId,
                    glob: this.props.glob,
                    instanceId: this.props.instanceId,
                    editMode: false
                }
            }
        );
    };

    handleDrop = (payload, toDirId) => {
        RMActions.resourceMoveStart(payload.instanceId, payload.resId, toDirId);
    };

    // private getBreadCrumb = () => {
    //     const selectedId = this.state.selectedDirId;

    //     if (selectedId > 0) {
    //         return <span> {selectedId} </span>;
    //     }
    // };

    getSingleSelectedResourceID = () => {
        const keys = Object.keys(this.state.selectedResources);

        if (keys.length === 1) {
            return keys[0];
        }

        return undefined;
    };

    handleOnEditButtonClick = (e) => {
        if (!this.checkResourceSelected()) {
            return;
        }

        const resource = RMStore.getFirstSelectedResource(this.props.instanceId);

        if (resource.res.mimetype.indexOf('image/') === -1) {
            this.props.glob.AppActions.showNotification_Success('Only Image Resources can be edited');
            return;
        }

        const singleSelectedResourceID = this.getSingleSelectedResourceID();
        const resourceValue: IImageResourceDialogResourceValue =
            singleSelectedResourceID != null
                ? {
                      resId: singleSelectedResourceID,
                      name: resource.res.name
                  }
                : {
                      resId: '0',
                      name: ''
                  };

        this.props.glob.DialogActions.createDialog(
            'Edit',
            null,
            () => {},
            () => {},
            () => {},
            'custom',
            {
                deny: false,
                confirm: false,
                FooterComponent: PopupFooterComp,
                footerComponentProps: {
                    resourceValue: resourceValue,
                    text: 'Upload'
                },
                Component: ImageResourceDialog,
                componentOptions: {
                    resourceValue: resourceValue,
                    selectedDirId: this.state.selectedDirId,
                    glob: this.props.glob,
                    instanceId: this.props.instanceId,
                    editMode: true
                }
            }
        );
        //this.setState({ selectedDirId: -1 });
        this.setState(this.getState());
    };

    private handleOnDownloadButtonClick = () => {
        if (!this.checkResourceSelected()) {
            return;
        }

        if (this.state.downloading) {
            return;
        }

        const resources = RMStore.getSelectedResources(this.props.instanceId);

        for (let index = 0; index < resources.length; index++) {
            const resource = resources[index];

            let filename = resource.res.name;

            if (resource.res.size === 0) {
                this.props.glob.AppActions.showNotification_Warning(
                    'The requested resource is empty. It cannot be dowloaded.'
                );
                return;
            }

            const xhr: any = new XMLHttpRequest();

            let def = $.Deferred();
            let _self = this;
            xhr.filename = filename;
            xhr.onreadystatechange = function () {
                if (this.readyState == 4) {
                    _self.setState(
                        _.extend(_self.state, {
                            downloading: false
                        })
                    );
                }

                if (this.readyState == 4 && this.status == 200) {
                    let filenameToSave = this.filename;
                    let minetype = this.response.type.toLowerCase();
                    let mimeType_ext = _.findWhere(MimeTypes.mimeTypes, {
                        mime: minetype
                    });
                    let { ext } = mimeType_ext != null ? mimeType_ext : { ext: null };

                    if (ext && ext.length > 0) {
                        const name = getBaseName(this.filename);

                        filenameToSave = name + '.' + ext;
                    }

                    saveAs.saveAs(this.response, filenameToSave);
                    _self.props.glob.AppActions.showNotification_Success(
                        'Please find downloaded file in your browser Downloads (' + filenameToSave + ').'
                    );

                    def.resolve();
                }
            };

            xhr.open('GET', resource.url);
            xhr.responseType = 'blob';
            xhr.send();

            this.setState(
                _.extend(this.state, {
                    downloading: true
                })
            );
        }
    };

    private handleOnReplaceButtonClick = () => {
        if (!this.checkDirectorySelected(true)) {
            return;
        }

        if (!this.checkResourceSelected()) {
            return;
        }

        if (this.state.downloading) {
            return;
        }

        const fileinput = this.references.fileUpload;

        fileinput.click();
    };

    private handleOnMoveResourceButtonClick = () => {
        if (this.checkResourceSelected()) {
            this.invokeMoveDialog(
                (dirid) => {
                    RMActions.resourceMoveStart(this.props.instanceId, _.keys(this.state.selectedResources), dirid);
                },
                'Select a folder to move Resource to',
                'Move'
            );
        }
    };

    private handleOnCopyResourceButtonClick = () => {
        if (this.checkResourceSelected()) {
            this.invokeMoveDialog(
                (dirid) => {
                    RMActions.resourceCopyStart(this.props.instanceId, _.keys(this.state.selectedResources), dirid);
                },
                'Select a folder to copy Resource to',
                'Copy'
            );
        }
    };
    private viewResource = () => {
        let showViewMenu;

        if (this.state.showViewMenu == false) {
            showViewMenu = true;
        } else {
            showViewMenu = false;
        }

        this.setState(
            _.extend(this.state, {
                showViewMenu: showViewMenu
            })
        );
    };

    private moveDir = (e) => {
        if (this.checkDirectorySelected(false)) {
            let root_dirid = this.state.RMState.resourceTreeRootDirId;
            let dir_obj = RMStore.getSelectedDir(this.props.instanceId);
            let title = 'Select a new parent folder for the folder "' + dir_obj.name + '"';

            this.invokeMoveDialog(
                (dirid) => {
                    this.props.glob.AppActions.dirsMove(
                        this.state.selectedDirId,
                        dirid,
                        this.state.dirTreeInstanceId,
                        root_dirid
                    );
                },
                title,
                'Move'
            );
        }

        e.stopPropagation();
        e.preventDefault();
    };

    private invokeMoveDialog = (successCallback, title, confirmTitle) => {
        this.props.glob.DialogActions.createDialog(
            title,
            '',
            function (dirid) {
                successCallback(dirid);
            },
            function () {},
            function () {},
            'custom',
            {
                deny: false,
                confirmTitle: confirmTitle,

                Component: DirResourceTree,
                componentOptions: {
                    glob: this.props.glob,
                    instanceId: this.props.instanceId,
                    root_dirid: this.state.RMState.resourceTreeRootDirId
                }
            }
        );
    };

    private getCKEditExternalInsert = () => {
        if (this.props.asCKEditExternalBrowser) {
            return (
                <div className="modal-footer" style={{ clear: 'both' }}>
                    <button className="btn btn-success JEST-res-ckeditor-insert" onClick={this.handleCKEditInsert}>
                        {'Insert'}
                    </button>

                    <button
                        className="btn btn-default"
                        onClick={() => {
                            window.close();
                        }}
                    >
                        {'Cancel'}
                    </button>
                </div>
            );
        }
    };

    private handleCKEditInsert = () => {
        if (this.checkResourceSelected()) {
            const resource = RMStore.getFirstSelectedResource(this.props.instanceId);

            let regex = /[?&]([^=#]+)=([^&#]*)/g,
                params = {},
                match;

            while ((match = regex.exec(window.location.href))) {
                params[match[1]] = match[2];
            }

            const funcNum = params['CKEditorFuncNum'] || 1;

            window.opener['CKEDITOR'].tools.callFunction(funcNum, resource.url);
            window.close();
        }
    };

    handleOnTakingPicture = () => {
        const fileInput = this.references.fileUpload;
        const files = fileInput.files;

        if (files == null || files.length == 0) {
            return;
        }

        const singleSelectedResourceID = this.getSingleSelectedResourceID();

        RMStore.postUpload(
            fileInput,
            true,
            this.props.instanceId,
            '',
            this.state.selectedDirId,
            singleSelectedResourceID ?? '0',
            files[0].name
        );
    };

    displayLargeIcons = () => {
        this.props.glob.AppStore.saveToLocalStorage('view', '0');

        this.setState(
            _.extend(this.getState(), {
                showViewMenu: false
            })
        );
    };

    displaySmallIcons = () => {
        this.props.glob.AppStore.saveToLocalStorage('view', '1');

        this.setState(
            _.extend(this.getState(), {
                showViewMenu: false
            })
        );
    };

    displayList = () => {
        this.props.glob.AppStore.saveToLocalStorage('view', '2');

        this.setState(
            _.extend(this.getState(), {
                showViewMenu: false
            })
        );
    };

    viewResourceButton = () => {
        const view = getStoredViewNumber(this.props.glob);

        let className: string;

        switch (view) {
            case 0:
                className = 'icon glyphicon glyphicon-th-large';
                break;
            case 1:
                className = 'icon glyphicon glyphicon-th';
                break;
            case 2:
                className = 'icon glyphicon glyphicon-th-list';
                break;
        }
        return (
            <div
                ref={(input) => {
                    this.references.btnView = input;
                }}
                key={'view-button'}
                className="add-button btn btn-default btn-sm bar-btn"
                onClick={this.viewResource}
            >
                <span className={className}></span>
                <span className="icon">{'View'}</span>
                <span className="caret"></span>
            </div>
        );
    };

    render() {
        const editPermissionsButton = (
            <div
                key={'perres-button'}
                className="add-button btn btn-default btn-sm bar-btn jest-res-dir-permissions"
                onClick={() => this.editPermissions()}
            >
                <span className="icon glyphicon glyphicon-pencil"></span>
                {'Permissions'}
            </div>
        );

        const moveDirButton = (
            <div
                key={'movedir-button'}
                className="add-button btn btn-default btn-sm bar-btn jest-res-dir-move"
                onClick={this.moveDir}
            >
                <span className="icon glyphicon glyphicon-move"></span>
                {'Move'}
            </div>
        );

        const renameButton = (
            <div
                key={'renamedir-button'}
                className="add-button btn btn-default btn-sm bar-btn jest-res-dir-rename"
                onClick={this.renameDir}
            >
                <span className="icon glyphicon glyphicon-edit"></span>
                {'Rename'}
            </div>
        );
        const numberOfSelectedResources = Object.keys(this.state.selectedResources).length;

        let downloadClass = 'disabled';
        let replaceClass = 'disabled';
        let editClass = 'disabled';
        let renameClass = 'disabled';
        let deleteClass = 'disabled';
        let moveClass = 'disabled';
        let copyClass = 'disabled';

        if (numberOfSelectedResources === 1) {
            downloadClass = '';
            replaceClass = '';
            editClass = '';
            renameClass = '';
            deleteClass = '';
            moveClass = '';
            copyClass = '';
        } else if (numberOfSelectedResources > 1) {
            downloadClass = '';
            replaceClass = 'disabled';
            editClass = 'disabled';
            renameClass = 'disabled';
            deleteClass = '';
            moveClass = '';
            copyClass = '';
        }

        let btnClass = ' btn btn-default btn-sm bar-btn ';
        let uploadClass = btnClass + ' jest-res-upload';

        downloadClass += btnClass + ' jest-res-download';
        replaceClass += btnClass;
        editClass += btnClass + ' jest-res-edit';
        renameClass += btnClass + ' jest-res-rename';
        deleteClass += btnClass + ' jest-res-delete';
        moveClass += btnClass + ' jest-res-move';
        copyClass += btnClass + ' jest-res-copy';

        const uploadButton = (
            <div key={'upload-button'} className={uploadClass} onClick={this.upload}>
                <span className="icon glyphicon glyphicon-upload"></span>
                {'Upload'}
            </div>
        );

        const editResourceButton = (
            <div key={'edit-button'} className={editClass} onClick={this.handleOnEditButtonClick}>
                <span className="icon glyphicon glyphicon-picture"></span>
                {'Edit'}
            </div>
        );

        const renameResourceButton = (
            <div key={'renameres-button'} className={renameClass} onClick={this.handleOnRenameResourceButtonClick}>
                <span className="icon glyphicon glyphicon-edit"></span>
                {'Rename'}
            </div>
        );

        const deleteResourceButton = (
            <div key={'delres-button'} className={deleteClass} onClick={this.handleOnDeleteResourceButtonClick}>
                <span className="icon glyphicon glyphicon-remove"></span>
                {'Delete'}
            </div>
        );

        const moveResourceButton = (
            <div key={'moveres-button'} className={moveClass} onClick={this.handleOnMoveResourceButtonClick}>
                <span className="icon glyphicon glyphicon-move"></span>
                {'Move'}
            </div>
        );

        const copyResourceButton = (
            <div key={'copyres-button'} className={copyClass} onClick={this.handleOnCopyResourceButtonClick}>
                <span className="icon glyphicon glyphicon-duplicate"></span>
                {'Copy'}
            </div>
        );

        const downloadButton = (
            <div key={'download-button'} className={downloadClass} onClick={this.handleOnDownloadButtonClick}>
                <span className="icon glyphicon glyphicon-download"></span>
                {'Download'}
            </div>
        );

        const replaceButton = (
            <div key={'replace-button'} className={replaceClass} onClick={this.handleOnReplaceButtonClick}>
                <span className="icon glyphicon glyphicon-transfer"></span>
                {'Replace'}
                <input
                    ref={(input) => {
                        this.references.fileUpload = input;
                    }}
                    type="file"
                    className="invisible"
                    onChange={this.handleOnTakingPicture}
                />
            </div>
        );

        if (
            this.state &&
            this.state.RMState &&
            this.state.RMState.resourceTreeRootDirId &&
            this.state.RMState.resourceTreeRootDirId > 0
        ) {
            const root_dirid = this.state.RMState.resourceTreeRootDirId;
            const instanceId = this.state.dirTreeInstanceId;
            const view = getStoredViewNumber(this.props.glob);

            let display = 'none';

            if (this.state.showViewMenu == true) {
                display = 'block';
            }

            let selected0 = {};
            let selected1 = {};
            let selected2 = {};

            switch (view) {
                case 0:
                    selected0 = { fontWeight: 'bolder' };
                    break;
                case 1:
                    selected1 = { fontWeight: 'bolder' };
                    break;
                case 2:
                    selected2 = { fontWeight: 'bolder' };
                    break;
            }

            if (permissions.editResources() === false) {
                return <span key={'span'}>{'You are not allowed to edit Resources.'}</span>;
            }

            return (
                <div className="pdc-widget-resource-manager">
                    <table className="resource-manager-table">
                        <thead className="resource-manager-thead">
                            <tr>
                                <td className="control-panel-header verticalLine" style={{ width: '30%' }}>
                                    <div>
                                        {<NewDirButton onClick={this.handleOnAddNewDir} />}
                                        {renameButton}
                                        {<DeleteButton onClick={this.handleOnDeleteDir} />}
                                        {moveDirButton}
                                        {editPermissionsButton}
                                    </div>
                                </td>

                                <td className="control-panel-header">
                                    <div>
                                        {uploadButton}
                                        {downloadButton}
                                        {replaceButton}
                                        {editResourceButton}
                                        {renameResourceButton}
                                        {deleteResourceButton}
                                        {moveResourceButton}
                                        {copyResourceButton}
                                        {this.viewResourceButton()}

                                        <div
                                            ref={(input) => {
                                                this.references.menuView = input;
                                            }}
                                            style={{ display: display }}
                                            className="resource-dropdown-menu"
                                        >
                                            <ul className="resource-ul">
                                                <li style={selected0}>
                                                    <div
                                                        className="add-button btn-default btn-sm bar-btn"
                                                        onClick={this.displayLargeIcons}
                                                    >
                                                        <span className="icon glyphicon glyphicon-th-large"></span>
                                                        {'Large Icons'}
                                                    </div>
                                                </li>
                                                <li style={selected1}>
                                                    <div
                                                        className="add-button btn-default btn-sm bar-btn"
                                                        onClick={this.displaySmallIcons}
                                                    >
                                                        <span className="icon glyphicon glyphicon-th"></span>
                                                        {'Small Icons'}
                                                    </div>
                                                </li>
                                                <li style={selected2}>
                                                    <div
                                                        className="add-button btn-default btn-sm bar-btn"
                                                        onClick={this.displayList}
                                                    >
                                                        <span className="icon glyphicon glyphicon-th-list"></span>
                                                        {'List'}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>

                        <tbody className="resource-manager-tbody">
                            <tr>
                                <td className="resource-manager-td verticalLine" style={{ width: '30%' }}>
                                    <div className="resource-manager-scroll">
                                        <DirsTree
                                            id={instanceId}
                                            rootId={root_dirid}
                                            rootName={'Resources'}
                                            expandedItems={this.state.expandedItems}
                                            select={this.state.selectedDirId}
                                            collapsed={false}
                                            //dragScope={this.dragScope}
                                            glob={this.props.glob}
                                            onSelect={(id) => {
                                                this.handleDirSelect(instanceId, id);
                                            }}
                                            onDrop={this.handleDrop}
                                        />
                                    </div>
                                </td>
                                <td className="resource-manager-td">
                                    <div className="resource-manager-scroll">
                                        <ResourceList
                                            instanceId={this.props.instanceId}
                                            view={view}
                                            glob={this.props.glob}
                                            onSelect={this.handleOnResourceSelected}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot className="resource-manager-tfoot">
                            <tr>
                                <td className="modal-footer"></td>
                                <td>{this.getCKEditExternalInsert()}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            );
        } else {
            return null;
        }
    }
}

function NewDirButton(props: { onClick(e): void }) {
    return (
        <div className="add-button btn btn-default btn-sm bar-btn jest-res-dir-add" onClick={props.onClick}>
            <span className="icon glyphicon glyphicon-plus"></span>
            {'New Folder'}
        </div>
    );
}

function DeleteButton(props: { onClick(e): void }) {
    return (
        <div className="add-button btn btn-default btn-sm bar-btn jest-res-dir-delete" onClick={props.onClick}>
            <span className="icon glyphicon glyphicon-remove"></span>
            {'Delete'}
        </div>
    );
}

// OE: Don't chage it is essential for componentRenderer modue
export default ResourceBrowser;

class PopupFooterComp extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    onClick = () => {
        let coords = this.props.resourceValue.selection;

        if (coords) {
            if (
                isNaN(coords.x) ||
                isNaN(coords.y) ||
                isNaN(coords.x2) ||
                isNaN(coords.y2) ||
                isNaN(coords.w) ||
                isNaN(coords.h)
            ) {
                this.props.glob.AppActions.showNotification_Warning('Select crop region');
            } else {
                this.props.success();
            }
        } else {
            this.props.success();
        }
    };

    render() {
        return (
            <div className="btn btn-success" onClick={this.onClick}>
                {this.props.caption || 'Upload'}
            </div>
        );
    }
}
